import { client } from '../common/client';
import type {
  GetPageMetaRequest,
  GetPageMetaResponse,
  GetCollectionDetailRequest,
  GetCollectionDetailResponse,
} from './utils/types';

export class PageAPIClient {
  public async getPageMeta(params: GetPageMetaRequest): Promise<GetPageMetaResponse> {
    try {
      const response = await client.get(`/page/meta`, {
        params: {
          path: params.pathname,
          ...(params.currency ? { currency: params.currency } : {}),
        },
      });

      if (!response.status) {
        console.error(`[PageAPIClient] Error fetching meta: ${response.status}`);
        throw new Error(`Failed to fetch page meta: ${response.status}`);
      }

      return response.data;
    } catch (error) {
      return {
        postId: 0,
        title: 'SkinSeoul',
        description: 'Korean Beauty Products',
        type: 'website',
        url: `https://skin-seoul.com${params.pathname}`,
      };
    }
  }

  /**
   * Fetch collection detail by slug
   * @param params - Collection detail request parameters
   * @returns Promise with collection detail data
   */
  public async getCollectionDetail(params: GetCollectionDetailRequest): Promise<GetCollectionDetailResponse> {
    return await client.get('/page/collectionDetail', { params }).then((res) => res.data);
  }
}

export const pageAPIClient = new PageAPIClient();
